import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseComponent } from './components/base/base.component';
import { CompanyStatisticsComponent } from '../statistics/company-statistics/company-statistics.component';
import { TransactionsComponent } from '../transactions/transactions.component';

const routes: Routes = [
  {
    path: '',
    component: BaseComponent,
    children: [
      {
        path: 'locations',
        loadChildren: () =>
          import('src/app/modules/locations/locations.module').then(
            (m) => m.LocationsModule
          ),
      },
      {
        path: 'loyalty-programs',
        loadChildren: () =>
          import('src/app/modules/loyalty-programs/loyalty-programs.module').then(
            (m) => m.LoyaltyProgramsModule
          ),
      },
      {
        path: 'coupons',
        loadChildren: () =>
          import('src/app/modules/coupons/coupons.module').then(
            (m) => m.CouponsModule
          ),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('src/app/modules/settings/settings.module').then(
            (m) => m.SettingsModule
          ),
      },
      {
        // The standalone personalization screen had a dead Save button
        // (no onSave wiring). Personalization now lives inside the loyalty
        // program editor, so redirect the old deep link there.
        path: 'personalization',
        redirectTo: 'loyalty-programs',
        pathMatch: 'full',
      },
      {
        path: '',
        component: CompanyStatisticsComponent,
      },
      {
        path: 'staff',
        loadChildren: () =>
          import('src/app/modules/user-management/user-management.module').then(
            (m) => m.UserManagementModule
          ),
      },
      {
        path: 'announcements',
        loadChildren: () =>
          import('src/app/modules/announcements/announcements.module').then(
            (m) => m.AnnouncementsModule
          ),
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('src/app/modules/notifications/notifications.module').then(
            (m) => m.NotificationsModule
          ),
      },
      {
        path: 'customer-loyalty',
        loadChildren: () =>
          import('src/app/modules/customer-loyalty/customer-loyalty.module').then(
            (m) => m.CustomerLoyaltyModule
          ),
      },
      {
        path: 'transactions',
        component: TransactionsComponent,
      },
      {
        path: 'transactions/:id',
        loadComponent: () =>
          import(
            'src/app/modules/transactions/transaction-details/transaction-details.component'
          ).then((m) => m.TransactionDetailsComponent),
      },
      {
        path: 'join-lomy',
        loadChildren: () =>
          import('src/app/modules/join-lomy/join-lomy.module').then(
            (m) => m.JoinLomyModule
          ),
      },
      {
        path: 'promotions',
        loadChildren: () =>
          import('src/app/modules/promotions/promotions.module').then(
            (m) => m.PromotionsModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LayoutRoutingModule {}
